module.exports = __webpack_public_path__ + "img/header-memoireRingsRedgold.aa933fe.webp";